(function () {
  var STAGGER_MS = 70;
  var observer = null;

  // Cancels the CSS failsafe in vg-animations.css; JS now owns the reveal.
  document.documentElement.classList.add('vg-reveal-ready');

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function init(root) {
    root.querySelectorAll('[data-vg-reveal-stagger]').forEach(function (container) {
      container.querySelectorAll(':scope > [data-vg-reveal]').forEach(function (item, i) {
        item.style.setProperty('--vg-reveal-delay', i * STAGGER_MS + 'ms');
      });
    });

    var targets = root.querySelectorAll('[data-vg-reveal]:not(.is-visible)');

    if (!('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );
    }

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Sections re-rendered by the theme editor arrive after init; observe them too.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
